// extracted by mini-css-extract-plugin
module.exports = {"nav-panel":"li","navPanel":"li","nav-panel-bg":"lj","navPanelBg":"lj","nav-panel-content":"lk","navPanelContent":"lk","none":"ll","block":"lm"};